import { render, staticRenderFns } from "./lclRealList.vue?vue&type=template&id=bb1098ea&scoped=true&"
import script from "./lclRealList.vue?vue&type=script&lang=js&"
export * from "./lclRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1098ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb1098ea')) {
      api.createRecord('bb1098ea', component.options)
    } else {
      api.reload('bb1098ea', component.options)
    }
    module.hot.accept("./lclRealList.vue?vue&type=template&id=bb1098ea&scoped=true&", function () {
      api.rerender('bb1098ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/list/lclRealList.vue"
export default component.exports